import { FC } from "react";
import styles from "./styles.module.scss";
import { ArrowSmallDownIcon, UserIcon } from "../../assets";
import { IProps } from "./types";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import UserColorBadge from "../UserColorBadge";
import UserBadge from "../UserBadge";

const UserItemCoachView: FC<IProps> = ({ item }): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClick = () => {
    if (item?.id) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("userId", item.id.toString());
      setSearchParams(newSearchParams);
    }
  };

  return (
    <div onClick={handleClick} className={styles.wrapper}>
      <div className={styles.nameBlock}>
        <div className={styles.avatarWrapper}>
          {item?.image ? (
            <img
              src={item?.image}
              className={styles.avatar}
              alt="User avatar"
            />
          ) : (
            <UserIcon />
          )}
        </div>
        <div className={styles.nameEmailContainer}>
          <span className={styles.name}>
            <UserBadge
              color={item?.color}
              isProd={!!item?.isProd}
              size="small"
            />
            {item?.firstName} {item?.lastName}{" "}
          </span>
          <p className={styles.email}>{item?.email}</p>
        </div>
        <UserColorBadge color={item?.color} />
      </div>
      <div className={styles.genderBlock}>
        <span className={styles.gender}>{item?.gender}</span>
      </div>
      <div className={styles.compDaysBlock}>
        <span className={styles.gender}>{item?.numberOfCompletedDays}</span>
      </div>
      <div className={styles.compDaysBlock}>
        <span className={styles.gender}>
          {item?.completedDaysPercentage !== undefined && item?.completedDaysPercentage !== null
            ? `${Math.round(item.completedDaysPercentage)}%`
            : "-"}
        </span>
      </div>
      <div className={styles.subscriptionBlock}>
        <span className={styles.subscription}>
          {item?.subscriptionType === "com.srama.subscription.6months"
            ? "6 Months"
            : item?.subscriptionType === "com.srama.subscription.3months"
            ? "3 Months"
            : item?.subscriptionType === "com.srama.subscription.monthly"
            ? "1 Month"
            : item?.subscriptionType === "com.srama.subscription.annual"
            ? "Annual"
            : item?.subscriptionType === "com.srama.subscription.onetimepayment"
            ? "Lifetime"
            : "-"}
        </span>
      </div>
      <div className={styles.subscriptionBlock}>
        <span className={styles.subscription}>
          {item?.subscriptionStatus === "expired"
            ? "Expired"
            : item?.subscriptionStatus === "trialing"
            ? "Free trial"
            : item?.subscriptionStatus === "renew_disabled"
            ? "Cancelled"
            : item?.subscriptionStatus === "active"
            ? "Active"
            : item?.subscriptionType === "com.srama.subscription.onetimepayment"
            ? "Lifetime"
            : "-"}
        </span>
      </div>

      <div className={styles.dateBlock}>
        <span className={styles.date}>
          {dayjs.utc(item?.onboardingAt).format("MMM DD, YYYY")}
        </span>
      </div>
      <div className={styles.dateBlock}>
        <span className={styles.date}>
          {item?.cancellationDate
            ? dayjs.utc(item?.cancellationDate).format("MMM DD, YYYY")
            : null}
        </span>
        <div className={styles.arrowButton}>
          <ArrowSmallDownIcon />
        </div>
      </div>
    </div>
  );
};

export default UserItemCoachView;
